import styled from 'styled-components';

export const Wrapper = styled.div`
  height: calc(100vh - 80px);
  display: flex;
  flex-flow: column nowrap;
  animation: fade-in 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);

  & > div:nth-child(2) {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
  }
`;

export const ContentWrapper = styled.div`
  overflow: hidden;
  animation: fade-in 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);

  & > div > div:first-child {
    width: 448px;
  }

  & > div > button:only-of-type {
    width: 384px;
  }

  & > div > button:last-child:not(:only-of-type) {
    width: 246px;
  }
`;

export const LoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--colorBlack);
  opacity: 0.5;
  z-index: 99999;
`;
